/**
 * Product With Purchase (PWP) popup management
 * Controls display timing and carousel functionality for promotional product offers
 */

import Flickity from 'flickity'
import { VisibilityElement } from '../custom-elements/visibility'

export class PWP {
  static PRODUCT_WITH_PURCHASE_ID = 'product-with-purchase'
  static PRODUCT_WITH_PURCHASE_SELECTOR = '[data-id="product-with-purchase"]'
  static PRODUCT_WITH_PURCHASE_SESSION_STORAGE_KEY = 'pwp-display-history'
  static CAROUSEL_SELECTOR = '.flickity-element'

  static showProductWithPurchase(): boolean {
    const productWithPurchase = document.querySelector(PWP.PRODUCT_WITH_PURCHASE_SELECTOR)

    // If PWP element doesn't exist or there's no global PWP data, exit early
    if (!productWithPurchase || !window.globals?.metaobjects?.product_with_purchase) {
      return false
    }

    const pwpData = window.globals.metaobjects.product_with_purchase
    const retriggerDelay = pwpData.retrigger_delay

    // Get last display time from session storage
    let lastDisplayed: Date | null = null
    try {
      const storageData = localStorage.getItem(PWP.PRODUCT_WITH_PURCHASE_SESSION_STORAGE_KEY)
      if (storageData) {
        lastDisplayed = new Date(storageData)
      }
    } catch (error) {
      console.error('Error parsing PWP display history:', error)
    }

    const now = new Date()

    // Check if we should show the PWP based on retrigger delay
    let shouldShow = true

    if (retriggerDelay > 0 && lastDisplayed) {
      // Calculate hours since last display
      const hoursSinceLastDisplay = Math.floor((now.valueOf() - lastDisplayed.valueOf()) / (1000 * 60 * 60))
      // Only show if enough hours have passed since last display
      shouldShow = hoursSinceLastDisplay >= retriggerDelay
    }

    if (shouldShow) {
      // Show the PWP
      VisibilityElement.dispatchShow(PWP.PRODUCT_WITH_PURCHASE_ID)

      // Update display history with current timestamp
      localStorage.setItem(PWP.PRODUCT_WITH_PURCHASE_SESSION_STORAGE_KEY, now.toISOString())

      PWP.reloadFlickity()
      return true
    }

    return false
  }

  static reloadFlickity() {
    const productWithPurchase = document.querySelector(PWP.PRODUCT_WITH_PURCHASE_SELECTOR)
    if (!productWithPurchase) return
    const carousel = productWithPurchase.querySelector(PWP.CAROUSEL_SELECTOR)
    if (carousel) {
      Flickity.data(carousel).resize()
    }
  }
}
